export default "__VITE_ASSET__f1252ee7__"